(() => {
  'use strict';

  const syncHeaderDrawerControls = () => {
    const hamburger = document.querySelector('[data-drawer-toggle="hamburger"]');
    const drawer = document.querySelector('.drawer--header[id]');

    if (!hamburger || !drawer) return;

    hamburger.setAttribute('aria-controls', drawer.id);
  };

  const init = () => {
    syncHeaderDrawerControls();
  };

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);

  window.setTimeout(init, 1500);
  window.setTimeout(init, 4000);
})();

